import { format } from "date-fns";

export class DateHelper {
  static getDate() {
    return new Date();
  }
}

export const useDate = (date = new Date(), formatString = "dd-MMM-yyyy") => {
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const stringDate = format(date, formatString);
  const formatDate = (string) => {
    const date = new Date(string);
    return format(date, formatString);
  };
  return { firstDay, lastDay, formatDate, stringDate };
};
